module.exports = __webpack_public_path__ + "img/预警信号.8426f965.png";